import '../../../assets/goodbye.scss'
import {
  Paper,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Stack,
} from '@mui/material'
import logoRTG from '../../../images/logo_rtg_black.svg'
import makeStyles from '@mui/styles/makeStyles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const useStyles = makeStyles((theme) => ({
  nested: {
    padding: theme.spacing(10),
  },
  listItem: {
    color: theme.palette.white.main,
  },
  logo: {
    filter:
      'invert(18%) sepia(44%) saturate(1598%) hue-rotate(182deg) brightness(98%) contrast(84%);',
    width: '100%',
    maxWidth: '496px',
    margin: '0px auto',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
    },
  },

  paperBack: {
    background: theme.palette.primary.light,
    position: 'absolute',
    minHeight: '450px',
    minWidth: '500px',
    margin: '0px 0px 50px 55px',
    maxWidth: '600px',
    maxHeight: '490px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  paperFront: {
    position: 'relative',
    maxWidth: '510px',
    maxHeight: '450px',
    width: '100',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },

  formBg: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '24px',
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
  },
  form: {
    height: '100%',
    width: '100%',
    maxWidth: '600px',
    maxHeight: '490px',
    display: 'flex',
    gap: theme.spacing(4),
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      maxWidth: 'unset',
    },
  },
  btn: {
    background: theme.palette.primary.main,
  },
  cardContent: {
    height: 'inherit',
    display: 'flex',
    maxHeight: 'calc(100% - 37%)',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignContent: 'stretch',
  },
}))

const Goodbye = () => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.formBg}>
        <Paper className={classes.paperBack} elevation={3}></Paper>
        <Card className={classes.paperFront} sx={{ minWidth: 'unset' }}>
          <img className={classes.logo} src={logoRTG} alt="logo" />
          <CardHeader
            className="text-center waviy side_menu_patient_logo:hidden"
            title="Do zobaczenia!"
          />
          <div className="flex flex-row items-center justify-center gap-2 p-4 h-auto side_menu_patient_logo_nd:hidden">
            <div className="container">
              <h1 className="title title1">Do</h1>
            </div>
            <div className="container">
              <h1 className="title title2">zobaczenia!</h1>
            </div>
          </div>
          <CardContent className={classes.cardContent}>
            <Stack className="flex justify-center items-center" spacing={4}>
              <FontAwesomeIcon
                className="text-custom_blue_dark"
                icon={['fad', 'house-return']}
                size="6x"
              />
            </Stack>
            <Typography
              variant="h6"
              className="flex justify-center items-center side_menu_patient_logo:hidden"
            >
              Dziękujemy za korzystanie z naszego systemu. Zapraszamy ponownie!
            </Typography>
            <div className="p-4 flex flex-wrap side_menu_patient_logo_nd:hidden">
              <div className="flex flex-row items-center justify-center gap-2 side_menu_patient_logo_nd:hidden">
                <div className="container">
                  <h1 className="title title9">Dziękujemy</h1>
                </div>
                <div className="container">
                  <h1 className="title title10">za</h1>
                </div>
                <div className="container">
                  <h1 className="title title3">korzystanie</h1>
                </div>
                <div className="container">
                  <h1 className="title title4">z</h1>
                </div>
                <div className="container">
                  <h1 className="title title5">naszego</h1>
                </div>
                <div className="container">
                  <h1 className="title title6">systemu.</h1>
                </div>
              </div>
              <div className="flex flex-row items-center justify-center gap-2 h-1/4 side_menu_patient_logo_nd:hidden">
                <div className="container">
                  <h1 className="title title7">Zapraszamy</h1>
                </div>
                <div className="container">
                  <h1 className="title title8">ponownie!</h1>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  )
}

export default Goodbye
